import type { RouteObject } from 'react-router'
import type { WaitForAuthResolutionFn } from '@/features/iam'
import type { ClientUserManagementFeature } from '@/features/client-user-management'
import { createClientUserDetailsViewLoader } from '@/features/client-user-management/client-user-management-route-loaders'

/**
 * Options for {@link createRoutes}.
 */
export interface CreateClientUserManagementRoutesOptions {
  clientUserManagement: ClientUserManagementFeature
  waitForAuthResolution: WaitForAuthResolutionFn
}

/**
 * Creates routes for the client user management feature.
 */
export function createRoutes(
  options: CreateClientUserManagementRoutesOptions,
): RouteObject[] {
  return [
    {
      path: '/clients',
      lazy: {
        Component: () =>
          import('@/features/client-user-management/ClientUserManagement/ClientUserManagementContainer').then(
            (r) => r.default,
          ),
      },
    },
    {
      path: '/clients/:userPublicId/*',
      loader: createClientUserDetailsViewLoader(options),
      lazy: {
        Component: () =>
          import('@/features/client-user-management/ClientUserDetails/ClientUserDetailsContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
